module.exports = __webpack_public_path__ + "fa-brands-400.513aa607d398efaccc55.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fontawesome/fa-brands-400.ttf
// module id = ../../../../../src/assets/fonts/fontawesome/fa-brands-400.ttf
// module chunks = main